/* eslint-disable @angular-eslint/prefer-standalone */
/* eslint-disable max-len */
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  inject,
} from "@angular/core";
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { SaveChangesOnDeactivate } from "src/app/guards/unsaved-changes.guard";
import { ResourceViewModel } from "../../view-models/ResourceViewModel";
import { AnlageViewModel } from "../../view-models/AnlageViewModel";
import { TaskActivityViewModel } from "../../view-models";
import {
  AdministrationClientProvider,
  RestUserExternal,
  TaskDetailDto,
  TasksClientProvider,
  TaskUpdateCommand,
  CalendarWeek,
  FormularDetailDto,
  FormulareClientProvider,
  FormularLookupDto,
  AnlagenClientProvider,
  EnumNameValueDto,
  ResourceListDto,
  EnumNamesValuesDto,
  ResourceType,
  TaskDetailInclude,
  ResourceConflictedResult,
  BelegDetailDto,
  BelegLookupDto,
  WawiBelegArt,
  ValidationResult,
  Operation,
  ArchivedFilter,
  AppointmentArrangement,
  TaskLocation,
  TaskTimePeriodsDto,
} from "src/app/web-api/web-api";
import {
  ITaskFormularCreateData,
  TaskFormularCreateComponent,
} from "../formular/create/task-formular-create.component";
import { TaskFormularTableComponent } from "../formular/table/task-formular-table.component";
import {
  ITaskFormularUpdateData,
  TaskFormularUpdateComponent,
} from "../formular/update/task-formular-update.component";
import { TypeGuards } from "src/app/helpers";
import { CstDialogsService } from "src/app/common-components/dialogs/cst-dialogs.service";
import { CstDialogResult } from "src/app/common-components/dialogs/cst-dialog-enums";
import { MasterDataService } from "src/app/services";
import {
  forkJoin,
  of,
  Subscription,
  BehaviorSubject,
  Subject,
  Observable,
  EMPTY,
  merge,
  NEVER,
} from "rxjs";
import {
  map,
  catchError,
  switchMap,
  finalize,
  tap,
  takeUntil,
  filter,
} from "rxjs/operators";
import { WawiApiBelegCreateDialogComponent } from "src/app/wawi-api/belege/create/dialog/dialog.component";
import { WawiApiBelegSelectDialogComponent } from "src/app/wawi-api/belege/select/dialog/beleg-select-dialog.component";
import { UserService } from "src/app/services/user.service";
import * as jsonpatch from "fast-json-patch";
import { BelegSelectingEvent } from "src/app/wawi-api/belege/select/dialog/beleg-selecting.event";
import {
  CstDateTimeService,
  TimeSpan,
} from "src/app/services/cst-date-time.service";
import { CstResponsivePopupService } from "src/app/common-components/resp-popup/services/resp-popup.service";
import { FormPlanungResourceSelectComponent } from "src/app/common-components/form-controls/_Planung/resources/select/resource-select.component";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CstEnumsGeneralService } from "src/app/services/enums/enums-general.service";
import { PermissionService } from "src/app/services/permission.service";
import { BFF_IsSaasInstance } from "src/app/injection-tokens/backend-feature-flags";
import { CstValidatorCalendarWeek } from "src/app/helpers/CstValidators";

@Component({
  selector: "app-task-detail",
  templateUrl: "./task-detail.component.html",
  styleUrls: ["./task-detail.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TaskDetailComponent
  implements OnInit, OnDestroy, SaveChangesOnDeactivate
{
  private _route = inject(ActivatedRoute);
  private _router = inject(Router);
  private _tasksClient = inject(TasksClientProvider);
  private _formularClient = inject(FormulareClientProvider);
  private _adminClient = inject(AdministrationClientProvider);
  private _masterData = inject(MasterDataService);
  private _anlageClient = inject(AnlagenClientProvider);
  private _dialog = inject(CstDialogsService);
  private _popupService = inject(CstResponsivePopupService);
  private _location = inject(Location);
  private _userService = inject(UserService);
  private _changeDetector = inject(ChangeDetectorRef);
  private _dts = inject(CstDateTimeService);
  private _perm = inject(PermissionService);
  enumService = inject(CstEnumsGeneralService);
  private _fb = inject(FormBuilder);
  isSaasInstance = inject(BFF_IsSaasInstance);

  public destroy$ = new Subject<void>();
  private _formChangeDestroy$ = new Subject<void>();
  public loading$ = new BehaviorSubject(false);

  @ViewChild(TaskFormularTableComponent)
  taskFormularTableView: TaskFormularTableComponent;
  @ViewChild("txtComment") _txtCommentRef: ElementRef;
  public get txtComment(): HTMLTextAreaElement {
    return this._txtCommentRef?.nativeElement;
  }

  @ViewChild("selectInlineClaimResourceID")
  _selectInlineClaimResourceID: FormPlanungResourceSelectComponent;

  isEditMode = false;
  model: TaskDetailDto;
  public claimResourceControl = new FormControl(null);
  anlageNrKomplett = "";
  anlageID = null;
  assignedToResource = "";
  claimByResource = "";
  status = "";
  workTimePlanned = "";
  workTimeReal = "";
  driveTimePlanned = "";
  driveTimeReal = "";
  private _fragmentSubscription: Subscription;

  changeModel: TaskUpdateCommand;

  dateRangesIsCollapsed = false;
  taskActivitiesIsCollapsed = false;
  Users: Array<RestUserExternal> = [];
  Resources: Array<ResourceViewModel> = [];
  ResourcesUsers: Array<ResourceViewModel> = [];
  ResourcesGroups: Array<ResourceViewModel> = [];
  TaskStates: EnumNameValueDto[] = [];
  Months: Array<any> = [];
  MinYear = new Date().getFullYear();
  rawCalendarWeek = "";
  calendarWeekRules = { W: /[0-5]/ };

  public formChange: FormGroup;

  public buOrderCreateItems = [
    {
      text: $localize`:@@TaskDetail_OrderSelect:Select an existing order...`,
      icon: "receipt",
      click: () => this.SetUrlFragment("orderSelect"),
    },
  ];

  public isEditingFormular = false;

  public editedFormularId: string | null = "";

  validationMessageCalendarWeekPattern = $localize`:@@PlanungAPI_TaskInsert_CalendarWeek_ValidationMessage:Must be in format CW/YYYY, eg. 19/2025, 43/2026, 51/2026`;
  validationMessageCalendarWeekInvalid = $localize`:@@PlanungAPI_TaskInsert_CalendarWeek_InvalidWeek:Week must be between 1 and 54`;

  private _initChangeModel() {
    this._formChangeDestroy$.next();
    this._formChangeDestroy$.complete();
    this._formChangeDestroy$ = new Subject<void>();

    this.formChange = this._fb.group({
      label: [null, [Validators.required]],
      claimResourceID: [null],
      assignedToResourceID: [null],
      appointmentArrangement: [null],
      todoDate: [null, [Validators.required]],
      todoTime: [null],
      workTimePlanned: new FormControl(null),
      workLocation: new FormGroup({
        driveTimePlanned: new FormControl(null),
        kilometresPlanned: new FormControl(null),
        street: new FormControl(null),
        streetNo: new FormControl(null),
        name: new FormControl(null),
        postalCode: new FormControl(null),
        city: new FormControl(null),
      }),
      description: [null],
      comment: [null],
      categoryID: [null],
      dueDate: [null],
      state: [null],
      anlageNrIntern: [null],
      rawCalendarWeek: [null, [Validators.required, CstValidatorCalendarWeek]],
    });
  }

  private _UpdateTodoTimeAfterInput(todoDate: Date, todoTime: Date) {
    let finalTodoTime: Date;
    if (!todoTime) {
      finalTodoTime = null;
    } else if (!todoDate) {
      finalTodoTime = todoTime;
    } else {
      const d = todoDate as Date;
      const t = todoTime as Date;
      finalTodoTime = new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        t.getHours(),
        t.getMinutes(),
        t.getSeconds(),
        t.getMilliseconds(),
      );
    }
    if (this.changeModel.todoTime === finalTodoTime) {
      return;
    }
    this.changeModel.todoTime = finalTodoTime;
    this.formChange.patchValue(
      { todoTime: finalTodoTime },
      { emitEvent: false },
    );
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public __InternalWorkTimePlannedAsDate: Date = null;
  public get WorkTimePlannedAsDate(): Date {
    return this._dts.ConvertTimeSpanStringToDate(
      this.changeModel.workTimePlanned,
    );
  }
  public set WorkTimePlannedAsDate(value: Date) {
    this.changeModel.workTimePlanned =
      this._dts.ConvertDateToTimeSpanString(value);
    this.__InternalWorkTimePlannedAsDate = value;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public __InternalWorkTimeRealAsDate: Date = null;
  public get WorkTimeRealAsDate(): Date {
    return this._dts.ConvertTimeSpanStringToDate(this.changeModel.workTimeReal);
  }
  public set WorkTimeRealAsDate(value: Date) {
    this.changeModel.workTimeReal =
      this._dts.ConvertDateToTimeSpanString(value);
    this.__InternalWorkTimeRealAsDate = value;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public __InternalDriveTimePlannedAsDate: Date = null;
  public get DriveTimePlannedAsDate(): Date {
    return this._dts.ConvertTimeSpanStringToDate(
      this.changeModel.workLocation.driveTimePlanned,
    );
  }
  public set DriveTimePlannedAsDate(value: Date) {
    this.changeModel.workLocation.driveTimePlanned =
      this._dts.ConvertDateToTimeSpanString(value);
    this.__InternalDriveTimePlannedAsDate = value;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public __InternalDriveTimeRealAsDate: Date = null;
  public get DriveTimeRealAsDate(): Date {
    return this._dts.ConvertTimeSpanStringToDate(
      this.changeModel.workLocation.driveTimeReal,
    );
  }
  public set DriveTimeRealAsDate(value: Date) {
    this.changeModel.workLocation.driveTimeReal =
      this._dts.ConvertDateToTimeSpanString(value);
    this.__InternalDriveTimeRealAsDate = value;
  }

  public get Settings() {
    return this._userService.CurrentUser.settings;
  }

  ngOnInit() {
    this._reinit();
    this.formChange
      ?.get("claimResourceID")
      ?.valueChanges.pipe(
        filter(() => !this.isEditMode),
        takeUntil(this.destroy$),
      )
      ?.subscribe((newClaim: any) => {
        const oldClaim = this.model.claimResourceID;
        if (oldClaim === newClaim) return;

        this._handleClaimResourcePatch(oldClaim, newClaim);
      });
  }

  private _initMonths() {
    this.Months = Array.from({ length: 13 }, (_, i) => {
      if (i === 0) return { value: 0, name: "-- kein --" };
      const date = new Date(2000, i - 1, 1); // Specific year avoids month-overflow bugs
      return {
        value: i,
        name: date.toLocaleString(undefined, { month: "long" }),
      };
    });
  }

  private _reinit() {
    this._initMonths();
    this._initChangeModel();
    this._loadData();
  }

  private _loadData() {
    this.loading$.next(true);

    const requests = {
      users: this.safePipe(this._adminClient.getAllUsers()),
      taskStates: this.safePipe(this._masterData.Tasks.GetTaskStates()),
      task: this.safePipe(this.getTaskStream()),
      resources: this.safePipe(this.getResourceStream()),
    };

    forkJoin(requests)
      .pipe(
        finalize(() => this.loading$.next(false)),
        takeUntil(this.destroy$),
      )
      .subscribe(({ users, taskStates, task, resources }) => {
        this.handleDataResponse(users, taskStates, task, resources);
      });
  }

  private getResourceStream(): Observable<ResourceViewModel[] | any> {
    return forkJoin({
      types: this._masterData.Resources.GetTypes(),
      res: this._masterData.Resources.GetResources(
        false,
        false,
        ArchivedFilter.AllEntries,
      ),
    }).pipe(
      map(({ types, res }) => {
        if (
          !TypeGuards.isOfType(types, EnumNamesValuesDto) ||
          !TypeGuards.isOfType(res, ResourceListDto)
        ) {
          throw new Error("Invalid Resource Data Structure");
        }
        return res.resources.map((r) => {
          const model = new ResourceViewModel(r);
          const match = types.namesValues.find((nv) => nv.value === r.type);
          model.typeName = match ? match.name : r.type.toString();
          return model;
        });
      }),
    );
  }

  private getTaskStream(includes?: TaskDetailInclude) {
    const id = this._route.snapshot.paramMap.get("id");
    includes = includes
      ? includes
      : TaskDetailInclude.TaskActivitiesAll |
        TaskDetailInclude.BelegDetails |
        TaskDetailInclude.Contacts;
    return this._tasksClient.getSingle(id, includes);
  }

  private handleDataResponse(
    users: any,
    states: any,
    task: any,
    resources: any,
  ) {
    if (TypeGuards.isArrayOfType(users, RestUserExternal)) this.Users = users;
    if (TypeGuards.isOfType(states, EnumNamesValuesDto)) {
      this.TaskStates = states.namesValues.filter((x) => x.value > 0);
    }
    if (TypeGuards.isArrayOfType(resources, ResourceViewModel)) {
      this.Resources = resources;
      this.ResourcesUsers = resources.filter(
        (e) => e.type === ResourceType.User,
      );
      this.ResourcesGroups = resources.filter(
        (e) => e.type === ResourceType.UserGroup,
      );
    }
    if (TypeGuards.isOfType(task, TaskDetailDto)) {
      this.model = task;
      this._InitModel();
    }
  }

  private _handleClaimResourcePatch(oldClaim: any, newClaim: any): void {
    this.loading$.next(true);

    const confirmChange$ = oldClaim
      ? this._dialog
          .Confirm(
            $localize`:@@TaskDetail_Confirm_ChangingClaimedUserCanResultInDataLoss:If a different active editor is entered, any changes saved offline by the previous editor cannot be saved and the data is lost. Therefore, only change the active editor if necessary.`,
          )
          .pipe(
            tap((result) => {
              if (result !== CstDialogResult.OK) {
                this.formChange.patchValue(
                  { claimResourceID: oldClaim },
                  { emitEvent: false },
                );
              }
            }),
            filter((result) => result === CstDialogResult.OK),
          )
      : of(CstDialogResult.OK);

    const patch = jsonpatch.compare(
      { claimResourceID: oldClaim },
      { claimResourceID: newClaim },
    ) as Operation[];

    confirmChange$
      .pipe(
        switchMap(() => this._tasksClient.patch(this.model.id, patch)),
        finalize(() => this.loading$.next(false)),
      )
      .subscribe((task) => {
        this.model.claimResourceID = task.claimResourceID;
        this.model.changed = task.changed;
        this.model.taskActivities = task.taskActivities;
        this._InitModel();
      });
  }

  private safePipe = (obs$: Observable<any>): Observable<any> => {
    return obs$.pipe(
      catchError((err) => {
        console.error(err);
        return of(err);
      }),
      takeUntil(this.destroy$),
    );
  };

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public SetUrlFragment(fragment: string) {
    this._router.navigate(["."], {
      relativeTo: this._route,
      fragment,
    });
  }

  public GetUserNameForTaskActivity(activity: TaskActivityViewModel): string {
    if (!activity.changeUserID) {
      return "System";
    }
    const user = this.Users.find((u) => u.id === activity.changeUserID);
    if (!user) {
      return "System";
    }
    return user.firstName + " " + user.lastName;
  }

  public OnTaskFormularCreate(): void {
    const popup = this._popupService.open<
      TaskFormularCreateComponent,
      ITaskFormularCreateData,
      FormularDetailDto
    >(TaskFormularCreateComponent, {
      data: {
        taskID: this.model.id,
        // id: model.id,
        anlageNr: this.model.anlageNrIntern,
      },
    });
    popup.afterClosed().subscribe((formular) => {
      if (!formular) {
        return;
      }
      this.model.formulare.push(formular);
      this.taskFormularTableView.dataSource.refresh();
    });
  }

  public OnTaskFormularChange(
    model: FormularLookupDto | FormularDetailDto,
  ): void {
    if (!model) {
      return;
    }
    const popup = this._popupService.open<
      TaskFormularUpdateComponent,
      ITaskFormularUpdateData,
      FormularDetailDto
    >(TaskFormularUpdateComponent, {
      data: {
        id: model.id,
        anlageNr: this.model.anlageNrIntern,
      },
    });
    popup.afterClosed().subscribe((formular) => {
      if (!formular) {
        return;
      }
      this.taskFormularTableView.RefreshItem(formular);
    });
  }

  public OnTaskFormularDelete(
    model: FormularLookupDto | FormularDetailDto,
  ): void {
    if (!model || !model.id) {
      return;
    }

    this._dialog
      .AskYesNo("Soll dieses Formular wirklich archiviert werden?")
      .subscribe((result) => {
        if (result !== CstDialogResult.Yes) {
          return;
        }
        this._formularClient.delete(model.id).subscribe(() => {
          const index = this.model.formulare.findIndex(
            (e) => e.id === model.id,
          );
          if (index < 0) {
            return;
          }
          this.model.formulare.splice(index, 1);
          this.taskFormularTableView.dataSource.refresh();
          if (!this.isEditMode) {
            this._reinit();
          }
        });
      });
  }

  private _InitModel() {
    this.model.taskActivities.sort(
      (a, b) => +b.changeDateTime - +a.changeDateTime,
    );
    let res = this.Resources.find(
      (e) => e.id === this.model.assignedToResourceID,
    );
    this.assignedToResource = res
      ? `${res.name}${res.archived ? " (Archiviert)" : ""}`
      : "---";
    res = this.Resources.find((e) => e.id === this.model.claimResourceID);
    this.claimByResource = res
      ? `${res.name}${res.archived ? " (Archiviert)" : ""}`
      : "---";
    this.status = this.TaskStates.find(
      (env: EnumNameValueDto) => env.value === this.model.state,
    ).name;
    this.anlageNrKomplett = "";
    this.anlageID = null;
    if (this.model.anlageNrIntern) {
      this.anlageNrKomplett = "...laden...";
      this._anlageClient.get(this.model.anlageNrIntern).subscribe(
        (anlage) => {
          this.anlageID = anlage.anlageID;
          this.anlageNrKomplett =
            anlage?.toString() ||
            `${
              this.model.anlageNrIntern
            } ${$localize`:Planung_TaskDetail_FacilityNoDeleted:[Deleted]`}`;
        },
        (_error) => {
          this.anlageNrKomplett = this.model.anlageNrIntern;
        },
      );
    }
    let ts = TimeSpan.fromString(this.model.workTimePlanned);
    this.workTimePlanned = `${ts.hours} Std. ${ts.minutes} Min.`;
    ts = TimeSpan.fromString(this.model.workTimeReal);
    this.workTimeReal = `${ts.hours} Std. ${ts.minutes} Min.`;
    ts = TimeSpan.fromString(this.model.workLocation.driveTimePlanned);
    this.driveTimePlanned = `${ts.hours} Std. ${ts.minutes} Min.`;
    ts = TimeSpan.fromString(this.model.workLocation.driveTimeReal);
    this.driveTimeReal = `${ts.hours} Std. ${ts.minutes} Min.`;

    if (!this._fragmentSubscription) {
      this._fragmentSubscription = this._route.fragment
        .pipe(takeUntil(this.destroy$))
        .subscribe((fragment) => {
          if (fragment === "orderSelect") {
            this.OnOrderSelect();
          }
          if (fragment === "orderCreate") {
            this.OnOrderCreate();
          }
        });
    }

    this.formChange.patchValue(
      { claimResourceID: this.model.claimResourceID },
      { emitEvent: false },
    );

    if (this.isSaasInstance) {
      this.model.dateRangesActive = true;
    }
  }

  public _OnFacilityNoSelected(facility: AnlageViewModel) {
    this._anlageClient
      .getStandort(undefined, facility.anlageNrIntern)
      .subscribe((ort) => {
        let fields = $localize`:@@TaskDetail_AdoptFacilityData_Fields:Work Location:
Name: ${ort.name}
Street: ${ort.street}
Street-No.: ${ort.streetNo}
City: ${ort.city}
Postal Code: ${ort.postalCode}
`;

        if (facility.anlageGroup) {
          fields +=
            "\n" +
            $localize`:@@TaskDetail_AdoptFacilityData_Fields_FacilityGroup:Facility Group: ${facility.anlageGroup}\n`;
        }

        this._dialog
          .AskYesNo(
            $localize`:@@TaskDetail_AdoptFacilityData:Do you want to adopt the data of the facility?` +
              "\r\n\r\n" +
              fields,
          )
          .subscribe((dlg) => {
            if (dlg !== CstDialogResult.Yes) {
              return;
            }

            this.formChange.patchValue({
              workLocation: {
                name: ort.name,
                street: ort.street,
                streetNo: ort.streetNo,
                city: ort.city,
                postalCode: ort.postalCode,
              },
            });
            const val = this.formChange.value;
            if (
              facility.anlageGroup &&
              val.anlageGroup !== facility.anlageGroup
            ) {
              this.formChange.patchValue({
                processingOrder: 0,
                anlageGroup: facility.anlageGroup,
              });
            }
            if (
              val.appointmentArrangement === AppointmentArrangement.None &&
              facility.appointmentArrangement
            ) {
              this.formChange.patchValue({
                appointmentArrangement: facility.appointmentArrangement,
              });
            }
          });
      });
  }

  public CanStartEditMode() {
    return (
      !this.model.claimResourceID ||
      this.model.claimResourceID === this._userService.CurrentUser.resourceID
    );
  }

  public OnStartEditMode() {
    this.loading$.next(true);

    const request = this.safePipe(
      this.getTaskStream(TaskDetailInclude.None),
    ).pipe(
      finalize(() => this.loading$.next(false)),
      catchError((err) => {
        console.error(err);
        this.isEditMode = false;
        return of(err);
      }),
    );

    request.subscribe((res) => this._handleStartEditModeData(res));
  }

  private _handleStartEditModeData(res: any) {
    this.model = res;
    this._InitModel();

    if (
      this.model.claimResourceID &&
      this.model.claimResourceID !== this._userService.CurrentUser.resourceID
    ) {
      this._dialog
        .Information(
          $localize`:@@TaskDetail_Information_CantEditTaskIsClaimedByOtherUser:This task can't be edited, because it is already claimed by another user.`,
        )
        .subscribe();
      return;
    }

    this.isEditMode = true;
    this.changeModel = new TaskUpdateCommand();
    this.changeModel.init({
      ...res,
      lastChanged: res.changed,
      categoryID: res.category?.id || null,
      todoDate: res.dateRanges?.todoDate || null,
      todoTime: res.dateRanges?.todoTime || null,
      pushNotificationTag: "",
    });

    if (!this.changeModel.dateRanges.plannedWeek) {
      this.changeModel.dateRanges.plannedWeek = new CalendarWeek();
    }

    const cw = this.changeModel.dateRanges.plannedWeek;
    if (cw.year && cw.week) {
      this.rawCalendarWeek = `${cw.week.toLocaleString(undefined, {
        minimumIntegerDigits: 2,
      })}/${cw.year.toLocaleString(undefined, {
        minimumIntegerDigits: 4,
        useGrouping: false,
      })}`;
    } else {
      this.rawCalendarWeek = null;
    }

    this.__InternalWorkTimePlannedAsDate =
      this._dts.ConvertTimeSpanStringToDate(this.changeModel.workTimePlanned);

    this.dateRangesIsCollapsed = false;
    this.formChange.patchValue(this.changeModel);
    this.formChange
      .get("rawCalendarWeek")
      ?.setValue(this.rawCalendarWeek, { emitEvent: false });

    this.formChange.valueChanges
      .pipe(takeUntil(merge(this._formChangeDestroy$, this.destroy$)))
      .subscribe((value: any) => {
        if (!this.changeModel) return;

        this.formChange.markAsDirty();

        this.changeModel.label = value.label;
        this.changeModel.claimResourceID = value.claimResourceID;
        this.changeModel.assignedToResourceID = value.assignedToResourceID;
        this.changeModel.appointmentArrangement = value.appointmentArrangement;
        this.changeModel.todoDate = value.todoDate;
        this._UpdateTodoTimeAfterInput(value.todoDate, value.todoTime);
        this.changeModel.workTimePlanned = value.workTimePlanned;

        if (!this.changeModel.workLocation) {
          this.changeModel.workLocation = new TaskLocation();
        }
        this.changeModel.workLocation.driveTimePlanned =
          value.workLocation.driveTimePlanned;
        this.changeModel.workLocation.kilometresPlanned =
          value.workLocation.kilometresPlanned;
        this.changeModel.workLocation.street = value.workLocation.street;
        this.changeModel.workLocation.streetNo = value.workLocation.streetNo;
        this.changeModel.workLocation.name = value.workLocation.name;
        this.changeModel.workLocation.postalCode =
          value.workLocation.postalCode;
        this.changeModel.workLocation.city = value.workLocation.city;

        this.changeModel.description = value.description;
        this.changeModel.comment = value.comment;
        this.changeModel.categoryID = value.categoryID;
        this.changeModel.dueDate = value.dueDate;
        if (!this.changeModel.dateRanges) {
          this.changeModel.dateRanges = new TaskTimePeriodsDto();
        }
        this.changeModel.dateRanges.todoDate = this.changeModel.todoDate;
        this.changeModel.dateRanges.todoTime = this.changeModel.todoTime;

        this.rawCalendarWeek = value.rawCalendarWeek;
        if (this.rawCalendarWeek && this.rawCalendarWeek.includes("/")) {
          const parts = this.rawCalendarWeek.split("/");
          this.changeModel.dateRanges.plannedWeek.week = parseInt(parts[0], 10);
          this.changeModel.dateRanges.plannedWeek.year = parseInt(parts[1], 10);
        }

        this.changeModel.state = value.state;
        this.changeModel.anlageNrIntern = value.anlageNrIntern;
      });

    setTimeout(() => this.txtComment?.select());
  }

  public CanAcceptEditMode() {
    const cm = this.changeModel;
    if (!cm || !cm.label || cm.label.trim() === "") {
      return false;
    }

    if (this.formChange?.invalid) {
      return false;
    }

    if (
      cm.dateRangesActive &&
      (!cm.dateRanges.todoDate ||
        cm.dateRanges.todoDate.getFullYear() < 1900 ||
        !cm.dateRanges.periodOfAction.month ||
        !cm.dateRanges.periodOfAction.year)
    ) {
      console.log(cm.dateRanges);
      console.log(this.formChange);
      return false;
    }
    if (!cm.dateRanges?.todoDate) {
      return false;
    }
    return true;
  }

  public OnAcceptEditMode(): void {
    if (!this.CanAcceptEditMode()) {
      return;
    }
    this._saveEditMode$().subscribe();
  }

  public hasUnsavedChanges(): boolean {
    return this.isEditMode && !!this.formChange?.dirty;
  }

  public canSaveChanges(): boolean {
    return this.CanAcceptEditMode();
  }

  public saveChanges(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.CanAcceptEditMode()) {
      return false;
    }
    return this._saveEditMode$().pipe(
      map(() => true),
      catchError(() => of(false)),
    );
  }

  private _saveEditMode$(): Observable<any> {
    const payload = { ...this.changeModel };

    return of(payload).pipe(
      switchMap((model) => this.guardResourceClaim$(model)),
      switchMap((model) => this.guardDate$(model)),
      tap(() => this.loading$.next(true)),
      map((model) => this.sanitizePayload(model)),
      switchMap((model) => this._tasksClient.update(model)),
      tap((result) => this.handleSuccess(result)),
      finalize(() => this.loading$.next(false)),
      catchError((error) => {
        this.handleError(error);
        return of(null);
      }),
    );
  }

  private guardResourceClaim$(model: any): Observable<any> {
    const hasClaimConflict =
      this.model.claimResourceID &&
      model.claimResourceID &&
      model.claimResourceID !== this.model.claimResourceID;

    if (!hasClaimConflict) return of(model);

    const message = $localize`:@@TaskDetail_Confirm_ChangingClaimedUserCanResultInDataLoss:If a different active editor is entered, any changes saved offline\nby the previous editor cannot be saved and the data is lost.\nTherefore, only change the active editor if necessary.`;

    return this._dialog
      .Confirm(message)
      .pipe(
        switchMap((res) => (res === CstDialogResult.OK ? of(model) : EMPTY)),
      );
  }

  private guardDate$(model: any): Observable<any> {
    const todo = this._dts.DateToInteger(model.dateRanges?.todoDate, false);
    const due = this._dts.DateToInteger(model.dueDate, true);

    if (todo <= due) return of(model);

    const opts: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };
    const dStr = model.dueDate?.toLocaleString(undefined, opts);
    const tStr = model.dateRanges?.todoDate?.toLocaleString(undefined, opts);

    const message = $localize`:@@TaskDetail_Ask_SetDueDateToTodoDate:The todo date \"${tStr}\" is after the due date \"${dStr}\".\nShould the due date be set to the todo date?\nOtherwise the due date must be adjusted.`;

    return this._dialog.AskYesCancel(message).pipe(
      switchMap((res) => {
        if (res === CstDialogResult.Yes) {
          model.dueDate = model.dateRanges.todoDate;
          return of(model);
        }
        return EMPTY;
      }),
    );
  }

  private sanitizePayload(model: any): any {
    if (model.assignedToResourceID?.trim() === "") {
      model.assignedToResourceID = null;
    }
    if (model.dateRanges?.plannedWeek && !model.dateRanges.plannedWeek.week) {
      model.dateRanges.plannedWeek = null;
    }
    return model;
  }

  private handleSuccess(result: any): void {
    this.model = result;
    this.changeModel = null;
    this.isEditMode = false;
    this._InitModel();
    this.loading$.next(false);
  }

  private handleError(error: any): void {
    let dialog$: Observable<any>;

    if (error instanceof ResourceConflictedResult) {
      const commentRemark = this.changeModel.comment
        ? $localize`:@@TaskDetail_ConflictedResult_CommentRemark:(except for the comment)`
        : " ";
      const msg = $localize`:@@TaskDetail_ConflictedResult:The task was changed by another user.\nYour changes${commentRemark}could not be saved.`;
      dialog$ = this._dialog.Warning(msg);
    } else if (error instanceof ValidationResult) {
      dialog$ = this._dialog.ErrorValidation(error.message, error);
    } else {
      dialog$ = this._dialog.Warning(
        JSON.stringify(error),
        $localize`:@@Dialog_Title_ErrorUnexpected:An Unexpected Error Occurred`,
      );
    }

    dialog$.subscribe(() => this.resetView());
    this.loading$.next(false);
  }

  private resetView(): void {
    this._formChangeDestroy$.next();
    this.changeModel = null;
    this.isEditMode = false;
    this._reinit();
  }

  public OnCancelEditMode() {
    this.resetView();
  }

  public CanOrderCreate() {
    if (
      !this.Settings ||
      !this.Settings.system ||
      !this.Settings.system.wawiAPI ||
      !this.Settings.system.wawiAPI.belsoftIsLicensed
    ) {
      return false;
    }
    return true;
  }

  public OnOrderCreate() {
    if (!this.model || !this.model.id || this.model.beleg) {
      this.SetUrlFragment(null);
      return;
    }

    const popup = this._popupService.open(WawiApiBelegCreateDialogComponent, {
      data: {
        taskID: this.model.id,
        anlageNrIntern: this.model.anlageNrIntern
          ? [this.model.anlageNrIntern]
          : [],
      },
    });
    const sub = popup.afterClosed().subscribe({
      next: (result) => {
        this.SetUrlFragment(null);
        sub.unsubscribe();
        if (!(result instanceof BelegDetailDto)) {
          return;
        }
        const dlgSub = this._dialog
          .Information(
            $localize`:@@TaskDetail_InfoBelegErstellt:The receipt was created successfully:
${result.sammelNr + " - " + result.belegNr}`,
          )
          .subscribe(() => dlgSub.unsubscribe());
        this._reinit();
      },
    });
  }

  public OnOrderSelect() {
    if (!this.model || !this.model.id || this.model.beleg) {
      this.SetUrlFragment(null);
      return;
    }

    const popup = this._popupService.open<
      WawiApiBelegSelectDialogComponent,
      { belegArt: number; anlageNr: string },
      any
    >(WawiApiBelegSelectDialogComponent, {
      data: {
        belegArt: WawiBelegArt.Auftrag,
        anlageNr: this.model.anlageNrIntern,
      },
    });

    popup.componentInstance.belegSelecting.subscribe(
      this._OnBelegSelecting.bind(this),
    );

    const sub = popup
      .afterClosed()
      .pipe(
        tap((result) => {
          this.SetUrlFragment(null);
          if (!result || !(result instanceof BelegLookupDto)) return;

          const belegSub = this._tasksClient
            .belegAssign(this.model.id, result.id)
            .subscribe((_) => {
              belegSub.unsubscribe();
              this._reinit();
            });
        }),
        catchError((error) => {
          console.error(error);
          return error;
        }),
        finalize(() => sub.unsubscribe()),
      )
      .subscribe();
  }

  public OnOrderUnassign() {
    if (!this.model || !this.model.id || !this.model.beleg) {
      return;
    }
    this._dialog
      .AskYesNo(
        $localize`:@@TaskDetail_Confirm_OrderUnassign:Do you really want to remove this task from the receipt?`,
      )
      .subscribe((result) => {
        if (result !== CstDialogResult.Yes) {
          return;
        }
        this._tasksClient.belegRemove(this.model.id).subscribe(
          () => {
            this._reinit();
          },
          (error) => console.error(error),
        );
      });
  }

  private _OnBelegSelecting(event: BelegSelectingEvent) {
    if (
      event.selected.belegArt === WawiBelegArt.Angebot ||
      event.selected.belegArt === WawiBelegArt.Auftrag ||
      event.selected.belegArt === WawiBelegArt.Bestellung
    ) {
      return;
    }

    event.shouldSubscribeToAsyncCancellation = true;
    this._dialog
      .Information(
        "Einer Aufgabe kann nur ein Angebot, ein Auftrag oder eine Bestellung zugeordnet werden.",
      )
      .subscribe(() => {
        event.isCancelled$.next(true);
      });
  }

  public CanSendNotification() {
    if (
      !this.Settings ||
      !this.Settings.system ||
      !this.Settings.system.azureNotificationHub ||
      !this.Settings.system.azureNotificationHub.isLicensed
    ) {
      return false;
    }
    return true;
  }

  public canDelete() {
    return this.model?.id && this._perm.UserCan_PlanungAPI_TaskArchive;
  }
  public OnDelete(): void {
    if (!this.canDelete()) {
      return;
    }
    this._dialog
      .AskYesCancelPromptString(
        $localize`:@@Dialogs_PlanungAPI_Tasks_ConfirmDeletion_Prompt_Single:Please specify a reason why you are deleting the task:`,
        $localize`:@@Dialogs_PlanungAPI_Tasks_ConfirmDeletion_Title_Single:Delete the task?`,
      )
      .subscribe((result) => {
        if (result === CstDialogResult.Cancel || typeof result !== "string") {
          return;
        }
        this._tasksClient
          .deleteSingle(this.model.id, result)
          .pipe(
            catchError((error) => {
              console.error(error);
              return NEVER;
            }),
          )
          .subscribe(() => {
            this._router.navigate([".."], { relativeTo: this._route });
          });
      });
  }

  public OnGoBack() {
    this._location.back();
  }

  public OnGoBackToTaskList() {
    this._router.navigate([".."], {
      relativeTo: this._route,
    });
  }

  public OnYearPeriodInputChange(isFirstCall: boolean) {
    if (isFirstCall) {
      if (!this.changeModel.dateRanges.periodOfAction.month) {
        this.changeModel.dateRanges.periodOfAction.month =
          new Date().getMonth() + 1;
      }
      if (!this.changeModel.dateRanges.periodOfAction.year) {
        this.changeModel.dateRanges.periodOfAction.month =
          new Date().getFullYear();
      }
      const d = this._dts.GetDateFromYearPeriod(
        this.changeModel.dateRanges.periodOfAction,
      );
      this.changeModel.dateRanges.todoDate = d;
      this.OnTodoDateInputChange(false);
    }
  }

  public OnCalendarWeekInputChange() {
    this.changeModel.dateRangesActive = true;
    const raw = this.formChange.get("rawCalendarWeek")?.value;

    if (raw && raw.includes("/")) {
      const parts = raw.split("/");
      const week = parseInt(parts[0], 10);
      const year = parseInt(parts[1], 10);

      this.changeModel.dateRanges.plannedWeek.week = week;
      this.changeModel.dateRanges.plannedWeek.year = year;

      const mondayOfKW = this._getMondayFromKW(year, week);
      this.changeModel.dateRanges.todoDate = mondayOfKW;
      this.formChange.patchValue(
        { todoDate: mondayOfKW },
        { emitEvent: false },
      );
    }
    this._changeDetector.detectChanges();
  }

  public OnTodoDateInputChange(_isFirstCall: boolean) {
    const value = this.formChange.get("todoDate")?.value;

    if (!value) return;

    const dateValue = new Date(value);
    const cw = this._dts.GetCalendarWeekFromDate(dateValue);

    if (cw) {
      const formattedKW = `${cw.week.toString().padStart(2, "0")}/${cw.year}`;
      this.rawCalendarWeek = formattedKW;

      this.formChange.patchValue(
        {
          rawCalendarWeek: formattedKW,
          todoDate: dateValue,
          dueDate: dateValue,
        },
        { emitEvent: false },
      );

      if (this.changeModel?.dateRanges) {
        this.changeModel.dateRanges.todoDate = dateValue;
        if (!this.changeModel.dateRanges.plannedWeek) {
          this.changeModel.dateRanges.plannedWeek = new CalendarWeek();
        }
        this.changeModel.dateRanges.plannedWeek.week = cw.week;
        this.changeModel.dateRanges.plannedWeek.year = cw.year;
      }
    }
  }

  public onEditFormular(event: EditFormularEvent) {
    this.isEditingFormular = true;
    this.editedFormularId = event.formularId;
  }

  public onFormularEditorClose() {
    this.isEditingFormular = false;
  }

  private _getMondayFromKW(year: number, week: number): Date {
    const fourthOfJanuary = new Date(year, 0, 4);
    const dayOfWeek = fourthOfJanuary.getDay();

    const firstMonday = new Date(fourthOfJanuary);
    firstMonday.setDate(
      fourthOfJanuary.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1),
    );

    const targetMonday = new Date(firstMonday);
    targetMonday.setDate(firstMonday.getDate() + (week - 1) * 7);

    return targetMonday;
  }
}

export interface EditFormularEvent {
  status: boolean;
  formularId: string | null;
}
